export default __webpack_public_path__ + "static/media/Button_Close.0dfc4db0.png";